// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"138db67a","239":"8a2bf4f6","455":"02080310"}[chunkId] + ".chunk.js";
};